export default "__VITE_ASSET__BvFwG_tj__"